import I18n from 'i18n-js'

export const enumSelectSmartest = [
  {
    id: 1,
    name: I18n.t('cruds.smartTest.enum.create'),
    action: 'create',
  },
  {
    id: 2,
    name: I18n.t('cruds.smartTest.enum.update'),
    action: 'update',
  },
  {
    id: 3,
    name: I18n.t('cruds.smartTest.enum.recordless'),
    action: 'recordless',
  },
]

export const codeVerification = {
  twilio: 'twilio',
  google2factor: 'google2factor',
}

export const enumTypeMessage = {
  simple: { key: 'simple' },
  pack: { key: 'pack' },
}

export const RECIPIENT_TYPE = {
  PATIENT: 'patient',
  RELATIVE: 'relative',
}

export const VIEWER_ROLE = {
  SELF: 'self',
  OTHER: 'other',
}

export const REPORT_ORIGIN = {
  SMART_PREDICT: 'smartPredict',
  PATIENT_REPORT: 'patientReport',
}

export const REPORT_OPTION = {
  DOWNLOAD: 'download',
}
